type MetricName = 'FCP' | 'LCP' | 'CLS';

type MetricPayload = {
  metric: MetricName;
  value: number;
  url: string;
};

const postMetric = (payload: MetricPayload) => {
  if (!navigator.sendBeacon) {
    fetch('/api/perf_metrics.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => null);
    return;
  }

  const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
  navigator.sendBeacon('/api/perf_metrics.php', blob);
};

export const initPerformanceMonitor = () => {
  if (!('PerformanceObserver' in window)) {
    return;
  }

  const observePaint = new PerformanceObserver((entries) => {
    for (const entry of entries.getEntriesByName('first-contentful-paint')) {
      postMetric({ metric: 'FCP', value: entry.startTime, url: window.location.href });
    }
  });
  observePaint.observe({ type: 'paint', buffered: true });

  const observeLCP = new PerformanceObserver((entries) => {
    const lastEntry = entries.getEntries().pop();
    if (lastEntry) {
      postMetric({ metric: 'LCP', value: lastEntry.startTime, url: window.location.href });
    }
  });
  observeLCP.observe({ type: 'largest-contentful-paint', buffered: true });

  let clsValue = 0;
  const observeCLS = new PerformanceObserver((entries) => {
    for (const entry of entries.getEntries()) {
      if ((entry as any).hadRecentInput) continue;
      clsValue += (entry as any).value || 0;
    }
    postMetric({ metric: 'CLS', value: clsValue, url: window.location.href });
  });
  observeCLS.observe({ type: 'layout-shift', buffered: true });
};
